import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    apolloXmlReports: [],
    count: 0,
    page: 1,
    pageSize: 5,
    pages: 0,
    sortField: 'created_at',
    sortOrder: 'desc',
    search: null,
    error: '',
    reportUpdate: false,
    apolloXmlReportId: null,
    apolloXmlCountBatches: [],
    accbCount: 0,
    accbPage: 1,
    accbPageSize: 5,
    accbPages: 0,
    accbSortField: 'created_at',
    accbSortOrder: 'desc',
    accbSearch: null,
    accbError: '',
    apolloXmlCountBatchId: null,
    apolloXmlCountBatchWorkers: [],
    yyyymmddPrefix: '',
    accbwCount: 0,
    accbwPage: 1,
    accbwPageSize: 5,
    accbwPages: 0,
    accbwSortField: 'created_at',
    accbwSortOrder: 'desc',
    accbwSearch: null,
    accbwError: ''
}

const receivedApolloXmlReportsData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        apolloXmlReports: results,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        search: search,
        reportUpdate: false
    }
}

const getApolloXmlReportsError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

const receivedApolloXmlCountBatchesData=(state, action)=>{
    const { results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    return {
        ...state,
        apolloXmlCountBatches: results,
        apolloXmlReportId: action.apolloXmlReportId,
        accbCount: count,
        accbPage: page,
        accbPageSize: pageSize,
        accbPages: pages,
        accbSortField: sortField,
        accbSortOrder: sortOrder,
        accbSearch: search
    }
}

const getApolloXmlCountBatchesError=(state, action)=> {
    return {
        ...state,
        accbError: action.error
    }
}

const receivedApolloXmlCountBatchWorkersData=(state, action)=>{
    const { yyyymmddPrefix,results,count,page,pageSize,pages,sortField,sortOrder,search } = action.data;
    const apolloXmlCountBatch = state.apolloXmlCountBatches.find(item => item.id==action.apolloXmlCountBatchId)
    
    return {
        ...state,
        apolloXmlCountBatchWorkers: results,
        apolloXmlCountBatchId: action.apolloXmlCountBatchId,
        yyyymmddPrefix: apolloXmlCountBatch.yyyymmdd_prefix,
        accbwCount: count,
        accbwPage: page,
        accbwPageSize: pageSize,
        accbwPages: pages,
        accbwSortField: sortField,
        accbwSortOrder: sortOrder,
        accbwSearch: search
    }
}

const getApolloXmlCountBatchWorkersError=(state, action)=> {
    return {
        ...state,
        accbwError: action.error
    }
}

const triggeredApolloXmlCountReport=(state)=>{
    return {
        ...state,
        reportUpdate: true
    }
}
export default reduce(initialState,{
    [actionTypes.GET_APOLLO_XML_COUNT_RPT_DATA]: receivedApolloXmlReportsData,
    [actionTypes.GET_APOLLO_XML_COUNT_RPT_DATA_ERROR]: getApolloXmlReportsError,
    [actionTypes.GET_APOLLO_XML_COUNT_BATCH_DATA]: receivedApolloXmlCountBatchesData,
    [actionTypes.GET_APOLLO_XML_COUNT_BATCH_DATA_ERROR]: getApolloXmlCountBatchesError,
    [actionTypes.GET_APOLLO_XML_COUNT_BATCH_WORKER_DATA]: receivedApolloXmlCountBatchWorkersData,
    [actionTypes.GET_APOLLO_XML_COUNT_BATCH_WORKER_DATA_ERROR]: getApolloXmlCountBatchWorkersError,
    [actionTypes.TRIGGER_APOLLO_XML_COUNT_REPORT]: triggeredApolloXmlCountReport
});


// WEBPACK FOOTER //
// ./src/redux/apolloXmlCount/reducer.js